export default {
  set(state, { data }) {
    state.visuais = data;
  },
  show(state, { data }) {
    state.visual = data;
  },
  getPage(state, { data }) {
    state.page = data
  }
}